import { connect } from 'react-redux';
import * as R from 'ramda';

// Component
import ChartSection from './ChartSection';

// Functions
import { getItem } from '../../store/rackWaitTimesSlice';

const mapState = R.applySpec({
  lastLocationDetailsFetchTime: getItem('lastLocationDetailsFetchTime'),
  locationDetails: getItem('locationDetails'),
  locationLoadTimes: getItem('locationLoadTimes'),
});

const mapDispatchToProps = {};

export default connect(mapState, mapDispatchToProps)(ChartSection);
